export const lightTheme = {
    body: 'white',
    text: 'black',
    button: '#FFF',
    buttonActive: '#bfbfbf',
    buttonText: 'black',
    backgroundSwitch: 'lightgray',
    shadow: 'black',
    tempoText: "#666"
}
export const darkTheme = {
    body: 'black',
    text: 'white',
    button: 'dimgray',
    buttonActive: '#e64040',
    buttonText: 'white',
    backgroundSwitch: '#383838',
    shadow: 'white',
    tempoText: "#666"

}